import { useState, useEffect, useContext } from 'react';
import SplashScreen from '../../Components/SplashScreen';
import { Box } from '@mui/material';
import HeaderWithSidemenu from '../../Components/Interpreter/Layouts/HeaderWithSidemenu';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Pusher from 'pusher-js';
import { notistackSnakebar } from '../../Utils';
import NotiFicationLogo from '../../Assets/logo192.png';
import { Typography } from '@mui/material';
import { AuthContext } from '../../Context/AuthProvider';

function InterpeterHome({ PusherDashboardTriggerSet, PusherDashboardTrigger }) {
    const { currentUser } = useContext(AuthContext);
    let iti_user_full_name = currentUser['custom:first_name'] + ' ' + currentUser['custom:last_name'];
    const [splashScreenLoad, splashScreenLoadSet] = useState(true);
    const [PusherMessagesArray, PusherMessagesArraySet] = useState({});
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser) {
            const splashScreenTimer = setInterval(clearSplashtimer, 1500);
            function clearSplashtimer() {
                splashScreenLoadSet(false);
                clearInterval(splashScreenTimer);
            }
        } else {
            const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
            Swal.fire({
                title: 'An Error Occured!',
                text: "No Token Found. Please Login.",
                icon: "error",
                confirmButtonText: "LOG IN",
                confirmButtonColor: 'red',
                color: appThemeColor,
                backdrop: true,
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/login');
                }
            });
        }

    }, []);

    useEffect(() => {
        if (PusherMessagesArray.event_status) {
            if (PusherMessagesArray.event_status === "dashboard_refresh_msg") {
                NotificationMessage({ title: (PusherMessagesArray.title) ? PusherMessagesArray.title : process.env.REACT_APP_NAME, message: PusherMessagesArray.body, variant: PusherMessagesArray.variant });
                notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: <Box>{(PusherMessagesArray.title) && <Typography variant='subtitle1'>{PusherMessagesArray.title} </Typography>}  <Typography variant='subtitle2'>{PusherMessagesArray.body} </Typography> </Box>, variant: PusherMessagesArray.variant, persist: true });
                PusherDashboardTriggerSet(PusherMessagesArray.trigger_time_utc);
            } else if (PusherMessagesArray.event_status === "sent_notification") {
                notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: <Box>{(PusherMessagesArray.title) && <Typography variant='subtitle1'>{PusherMessagesArray.title} </Typography>}  <Typography variant='subtitle2'>{PusherMessagesArray.body} </Typography> </Box>, variant: PusherMessagesArray.variant });
            }
        }
    }, [PusherMessagesArray]);

    useEffect(() => {
        const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
            cluster: process.env.REACT_APP_PUSHER_CLUSTER
        });
        if (currentUser) {
            let pusher_user_id = btoa(currentUser['custom:talent_id']);
            let channel = pusher.subscribe(process.env.REACT_APP_PUSHER_PREFIX_INTERPRETER_CHANNEL_NAME + pusher_user_id);
            if (channel) {
                channel.unbind('trigger_event').bind("trigger_event", (data) => {
                    PusherMessagesArraySet(data);
                });
            }
        }
    }, []);

    function NotificationMessage(props) {
        try {
            if (!("Notification" in window)) {
                notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: props.message, variant: props.variant, preventDuplicate: true });
                console.log('Your browser is not supported nofications.');
            } else if (Notification.permission === "granted") {
                navigator.serviceWorker.ready.then(function (registration) {
                    registration.showNotification(props.title, {
                        body: props.message,
                        icon: NotiFicationLogo,
                        requireInteraction: true
                    });
                });
            } else if (Notification.permission === "default") {
                Notification.requestPermission().then((permission) => {
                    if (permission === "granted") {
                        navigator.serviceWorker.ready.then(function (registration) {
                            registration.showNotification(props.title, {
                                body: props.message,
                                icon: NotiFicationLogo,
                                requireInteraction: true
                            });
                        });
                    }
                });
            }
        } catch (e) {
            notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: props.message, variant: props.variant, preventDuplicate: true });
            console.log('An error occured in notifications');
        }
    }

    return (
        <Box>
            {splashScreenLoad && <SplashScreen username={iti_user_full_name} />}
            {!splashScreenLoad && <HeaderWithSidemenu PusherDashboardTrigger={PusherDashboardTrigger} />}
        </Box>
    )
}

export default InterpeterHome;